<div id="spec-range-selector-btn-container"
     [ngClass]="{'is-selected': selectedIndex == index, 'disabled': rangeCount?.count < 1 && text == null, 'prevent-select': rangeCount?.count < 1 && text == null}"
     (click)="onClick()"
>
    <div *ngIf="text == null" id="spec-range-color" [ngStyle]="{'background-color': rangeCount?.color}"></div>
    <div *ngIf="text == null" id="spec-range-count">{{rangeCount?.count || 0}}</div>
    <div *ngIf="text != null" id="spec-no-filter">{{text}}</div>
</div>
